import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LocationSalesData } from '../types/dashboard.types';

interface LocationSalesChartProps {
  data: LocationSalesData[];
}

export const LocationSalesChart: React.FC<LocationSalesChartProps> = ({ data }) => {
  // Formatear nombres de sucursales para mejor visualización
  const formatLocationName = (name: string): string => {
    return name.replace('Local ', '');
  };

  // Formatear valor de moneda para tooltips
  const formatCurrency = (value: number): string => {
    return `S/ ${value.toLocaleString('es-PE', { minimumFractionDigits: 2 })}`;
  };

  const chartData = data.map(location => ({
    ...location,
    displayName: formatLocationName(location.locationName)
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Ventas por Sucursal</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="displayName" 
              axisLine={false}
              tickLine={false}
              fontSize={12}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              fontSize={12}
              tickFormatter={(value) => `S/ ${value / 1000}k`}
            />
            <Tooltip
              formatter={(value: number, name: string) => [
                name === 'revenue' ? formatCurrency(value) : value,
                name === 'revenue' ? 'Ingresos' : 
                name === 'orders' ? 'Órdenes' : 'Ventas'
              ]}
              labelFormatter={(label) => `Sucursal: ${label}`}
            />
            <Bar
              dataKey="revenue"
              fill="#F43F5E"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};